// @flow

import { type Axios } from 'axios'

export type Lot = {|
  area: number,
  available: boolean,
  floorLabel: string,
  floorId: string,
  displayOnFloors: { code: string, floorId: string }[],
  buildingId: string,
  buildingLabel: string,
  label: string,
  labelVirtualTour?: string,
  links: {
    virtual_tour?: string,
    plan: string,
    configurator?: string,
  },
  lotId: string,
  priceIncludingTaxes: {|
    amountIncludingTaxes: number,
    vatInPercent: number,
  |},
  hidePrice: boolean,
  typology: string,
  haveParking: boolean,
  numberOfParking: ?number,
|}

export type ProgramPayload = {|
  numberOfLots: number,
  programId: string,
  label: string,
  location: string,
  developerName: string,
  links: {
    privacy_policy?: string,
    terms_of_use?: string,
    program_preview?: string,
    contact?: string,
  },
|}

type FloorPreview = {
  fieldOfView: number,
  camera: string,
  startFrame: number,
  views: {
    /* camera: {
      position: Coordinate,
      target: Coordinate,
    }, */
    paths: {
      desktop: {
        jpg: string,
        webp: string,
      },
      mobile: { jpg: string, webp: string },
    },
    offset: number,
  }[],
}

type Building = {
  buildingId: string,
  buildingLabel: string,
  buildingCode: string,
  availableTypologies: ?(string[]),
  availableLotOrParking: boolean,
  floors: {
    floorId: string,
    floorPreview: FloorPreview,
    floorLabel: string,
    level: number,
    availableTypologies: ?(string[]),
    availableLotOrParking: boolean,
    links: ?{ plan: string },
  }[],
  atticPreview?: FloorPreview,
  generalPreview: FloorPreview,
  streetPreview: FloorPreview,
}

export type ProgramPreviewPayload = {|
  program: {
    buildings: Building[],
    generalPreview?: FloorPreview,
    streetPreview?: FloorPreview,
    landingPreview?: FloorPreview,
    modelizationPath: string,
    resolutionRatio: { mobile: number, desktop: number },
    developerWebsiteUrl: string,
  },
  lots: Lot[],
|}

export const fetchProgramPreview = async (
  httpClient: Axios,
  programPreviewApiEndpoint: string,
): Promise<ProgramPreviewPayload> =>
  (await httpClient.get(programPreviewApiEndpoint)).data

export const fetchProgram = async (
  httpClient: Axios,
): Promise<ProgramPayload> => (await httpClient.get('/api/program')).data

type OneFieldErrorPayload = {| field: ?string, message: string |}

export const postContact = async (
  httpClient: Axios,
  firstName: string,
  lastName: string,
  email: string,
  phone: string,
): Promise<OneFieldErrorPayload[]> => {
  try {
    await httpClient.post(
      '/api/contact',
      {
        firstName,
        lastName,
        email,
        phone,
      },
      {},
    )
  } catch (err) {
    if (err.response && err.response.status === 400) {
      return err.response.data.map(oneError => ({
        field: oneError.source,
        message: oneError.message,
      }))
    }

    throw err
  }

  return []
}
